<template>
    <ResetForm />
</template>

<script>
import ResetForm from "@/components/ResetForm.vue";

export default {
    name: 'ResetFormView',
    components: {
        ResetForm
    }
}
</script>
